import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { ChangePassword } from '../../actions/user.js';

class UpdatePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: undefined,
            newpassword: undefined,
            newpasswordconfirm: undefined,
            passwordsMismatch: false
        };
    }
    updatePassword(e){
        var newState = {
			password: e.target.value,
        }
		this.setState(newState);
    }
    updateNewPassword(e){
		var newState = {
            newpassword: e.target.value,
        }
        this.setState(newState);
    }
    updateNewPasswordConfirm(e){
		var newState = {
            newpasswordconfirm: e.target.value
        };
        this.setState(newState);
	}
    changePassword(e) {
        if(this.state.newpassword != this.state.newpasswordconfirm) {
            this.setState({passwordsMismatch: true});
            return false;
        }
        else {
            ChangePassword(this.state.password, this.state.newpassword, this.state.newpasswordconfirm);
            this.setState({passwordsMismatch: false});
        }
        return true;
        e.preventDefault();
    }
    render() {
        return (
            <div className="profile-form-container">
                <br /><br /><br />
                <input className="form-field" type="password" placeholder="Your current password" name="password" value={this.state.password} onChange={this.updatePassword.bind(this)}/><br />
                <input className="form-field" type="password" placeholder="New password" name="new_password" value={this.state.newpassword} onChange={this.updateNewPassword.bind(this)}/><br />
                <input className="form-field" type="password" placeholder="New password again" name="new_password_confirm" value={this.state.newpasswordconfirm} onChange={this.updateNewPasswordConfirm.bind(this)}/><br />
                {
                    (this.state.passwordsMismatch) ?
                    <div className="password-mismatch-error">Passwords Do Not Match</div>
                    :
                    <span></span>
                }
                <br />
                <input className="register-button" type="submit" value="Update Password" onClick={this.changePassword.bind(this)}/>
            </div>
        )
    }
}

export default (UpdatePassword);


// WEBPACK FOOTER //
// ./src/components/dashboards/updatePassword.js